/** @module FormulatedProduct/FoodSamplesForm */
define([
	"dojo/_base/declare",
	"csi",
	"csi/_base/underscore",
	"csi/comm",
	"csi/locale",
	"csi/reflection",
	"csi/xml",
	"./_FormulatedProductSampleFormMixin"
], function(declare,csi,_,comm,locale,reflection,xml,_FormulatedProductSampleFormMixin) {


	return declare([_FormulatedProductSampleFormMixin], {

		/**
		 * @override
		 * Set proper parent for client ProductSource node
		 */
		onCreateFormNode: function(node, type) {
			if (type === "FoodSource") {
				const product = this.cacheView.get(this.urlProduct);
				if (product) {
					node.__Parent__ = product.ProductSourcing;
				}
			}
		},

		_getProductSetup: function() {
			// summary: if product is known, then return instance of product setup class
			if(!this.urlProduct && this._typeSample == "FoodSample") return null;
			if (!this._productSetup) {
				var	ctr = csi.syncRequire(this._productSetupClass);
				this._productSetup = new ctr();
			}
			return this._productSetup;
		},

		_updateStatistics: function() {
			const {cacheView, rightWidget, defView} = this;

			if (!rightWidget)
				return; // we're here too early

			let products = [];
			let sourcesLength = 1;

			const parentNode = defView.getSource().getParent();
			if (parentNode.$Type == "FoodSourcing") {
				products = [parentNode.__Parent__];
			} else if (parentNode.$Type == "Food") {
				products = [parentNode.$URL];
			} else if (parentNode.$Type == "FoodSource") {
				products = [cacheView.getNode(parentNode.__Parent__).__Parent__];
			} else {
				const lineItems = this.getFieldValue(this.LINE_ITEM);
				if (Array.isArray(lineItems)) {
					for (const li of lineItems) {
						products.push(cacheView.getNode(li).SRLineItemProduct);
					}
				}
			}

			if (this.getField(this.SUPPLIER)) {
				sourcesLength = this.getFieldValue(this.SUPPLIER).length;
			}


			const qty = this.getFieldValue(this.QUANTITY);

		},


		_setProductType: function(/*String*/type) {
			// summary: determine sample type based on product type
			this._typeSample = "FoodSample";
			if (!this._typeSample) {

				var	fSampleType = this.defView.getField("SampleType");
				if (fSampleType) {
					fSampleType.m_rca = reflection.getClass(this._typeSample).getAttribute(fSampleType.m_id);
				}
			}
		},

		_toWriterProductSamples: function(/*Controller*/ac, /*String*/urlProduct, /*String*/urlSource, /*String?*/urlLineItem) {
			// summary: create samples of selected
			var w = ac.m_writer;
			var fd = this.defView.m_formData;
			var type = this._typeSample;
			const prefix = this.generateSampleName(urlSource);
			var qty = fd.getFieldValue(this.QUANTITY, true) || 1; // default of 1
			var urlStorage = fd.getFieldValue(this.SAMPLE_STORAGE, true);
			var samples = [];

			// batch size
			var config = reflection.getObject("centric://REFLECTION/INSTANCE/SourcingModule/Configuration");
			var batchSize = config.SampleCreationBatchSize || 20; // 20 is default

			var nameField = this.defView.getField("Node Name");
			var nameHasExpr = (nameField && nameField.hasExpression());
			var self = this;

			var createSamples = function(n, urlProductLocal) {
				for (var i = 1; i <= n; ++i) {
					// if there is a urlLineItem, make sure we have a matching urlLineItemLocal if there is one
					if (!urlLineItem || !urlProductLocal || cache.getNode(urlLineItem).SRLineItemProduct == urlProductLocal) {
						var	url = comm.createUrl(type);

						var	cn = w.createNode(url, type, name);

						ac.toWriterFields(url, fd);

						// see if there is an expression on Node Name set by the Business Object - if so, ignore this next part
						if (nameField && !nameHasExpr) {
							//Found that any string in double quotes were resulting in error while evaluating expression.Added this unicode replacement to fix that.
							var exp = "\"" + prefix.replace(/\"/g,"\\u0022") + "\"";


							if (n > 1) {
								exp += "+ \"-" + i + "\"";
							}

							// use one-time expression for Name
							cn.changeAttributeExp("Node Name", exp, true); // one time expr
						}

						if (urlLineItem) {
							cn.changeAttribute("SampleSRLineItem", xml.ATTR_REF, urlLineItem);
						}

						w.callMethod("FormulatedProduct", "FormulatedProductAddSamples")
							.addParameter("ProductURL", xml.ATTR_REF, urlProduct)
							.addParameter("SourceURL", xml.ATTR_REF, urlSource)
							.addParameter("SampleStorageURL", xml.ATTR_REF, urlStorage)
							.addParameter("SampleURLs", xml.ATTR_REFLIST, [url])
							.addParameter("ParentURL", xml.ATTR_REF, ac.getParentURL());

						// if only one sample created, then use name given rather than name constructed from color, size and qty
						if (n == 1) {
							w.changeNode(url).changeAttribute(xml.ATTR_NAME, xml.ATTR_STRING, prefix);
						}

						w.validateNode(url, true);

						self.batchSampleCtr ++;
						if (self.batchSampleCtr == batchSize) {
							w.flushChanges();
							self.batchSampleCtr = 0;
						}

						samples.push(url);
					}
				}
			};

			var quantity = Number(qty);

			createSamples(quantity, null, null);

			return samples;
		}
	});
});